import React from 'react';
import { Messages, Control, API, Code, Name, Title, Actions, Form, Hooks, Files, Toast, Button, useListContext, useCallback, useEffect, useState, Utility } from 'helpers/ListImports';
import { ExamType } from 'models/ExamTypeModel';


const ExamTypeList: React.FC = () => {
  const width = { name: 30, comment: 70 }
  const [formId, formName] = [Code.Form.Id.EXAMTYPE, Code.Form.Name.EXAMTYPE];
  const { loading, setLoading, error, setError, search, setSearch, pno, setPno, rows, setPageRow, activeId, setActiveId, selected, setSelected, confirm, setConfirm, message, setMessage,  showMenu, setShowMenu, selectedItems, setSelectedItems, selectAllChecked, setSelectAllChecked, activeOptions, setActiveOptions, rowOptions, setRowOptions, menuPosition, setMenuPosition, iframeRef, filterRef, contextMenuRef  } = useListContext();
  const [examtypeData, setExamTypeData] = useState<ExamType[]>([]); 
  const [selectedExamType, setselectedExamType] = useState<ExamType | null>(null);
  const [segmentId, setSegmentId] = useState<number>(1);
  const [categoryId, setCategoryId] = useState<number>(1);
  const [segmentOptions, setSegmentOptions] = Hooks.Form.Options();
  const [categoryOptions, setCategoryOptions] = Hooks.Form.Options();
  const triggers = [pno, rows, search, activeId, segmentId, categoryId];
  const Privilege = Hooks.Privilege.List(formId);
  
  Hooks.Privilege.HasView(Privilege);
  
  Form.Click.Outside([contextMenuRef, filterRef],[() => setShowMenu(false),() => {}],true);
  Form.Select.OnChange(selectedItems, setSelected);

  useEffect(() => {
    Files.Json.API(Code.Form.Name.SEGMENT, Code.Option.Common.ALL, setSegmentOptions, setError);
    Files.Json.API(Code.Form.Name.CATEGORY, Code.Option.Common.ALL, setCategoryOptions, setError);
    Files.Json.Http(Code.File.ACTIVE, Code.Option.Common.NOTHING, setActiveOptions, setError);
    Files.Json.Http(Code.File.ROW, Code.Option.Common.NOTHING, setRowOptions, setError);
  }, []);

  useEffect(() => {
    callListData(); 
  }, triggers);
 
  const callListData = useCallback(async () => {
    const url = API.Build.ListApiEndpoint(formName, pno, rows, Name.ExamType.Id, Code.Option.Sort.DESC, activeId, search, {
      fields: Utility.Join.Fields([
        Name.ExamType.Id, 
        Name.ExamType.Name, 
        Name.ExamType.Comment, 
      ]),
    });
     
    await API.Data.List<ExamType>(url, setExamTypeData, setError, setLoading); 
  }, triggers);

  return (
    <Control.List.Frame>
      <Control.List.Panel>
        <Control.List.Tools>
          <Control.Tool.Left>
            <Button.Create title={formName} onClick={() => Form.Show.Popup(iframeRef, formName)} Privilege={Privilege} />
            {selected && ( <Button.Delete onClick={()=>Toast.Delete.MultipleRecords(activeId, selectedItems, setConfirm)} activeId={activeId} Privilege={Privilege} /> )}
          </Control.Tool.Left>
          <Control.Tool.Right>
            <Control.SearchBar onSearch={setSearch} onFilterToggle={() => Form.Show.Filter(filterRef)}  onGoClick={() => callListData()} />
            <Control.List.Filter filterRef={filterRef}>
              <Control.Dropdown title={Title.Segment} options={segmentOptions} onChange={(value) => { setSegmentId(value);  callListData();  }} />
              <Control.Dropdown title={Title.Category} options={categoryOptions} onChange={(value) => { setCategoryId(value);  callListData();  }} />
              <Control.Dropdown title={Title.State} options={activeOptions} onChange={setActiveId} />
              <Control.Dropdown title={Title.Rows} options={rowOptions} onChange={setPageRow} />
            </Control.List.Filter>
            <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.MultiDelete(formName, activeId, callListData, selectedItems, setConfirm, setMessage, setSelected, setSelectedItems, setError) } onRefuse={() => setSelectedItems([])} />
          </Control.Tool.Right>
        </Control.List.Tools>
        <Control.List.Data>
          <Control.List.Box>
            <Control.List.Title>
              <Control.SelectAll selectAllChecked={selectAllChecked} onSelectAll={(e) => Form.Select.All(e, setSelectedItems, examtypeData, setSelectAllChecked,formName)} extra={1} />
              <Control.Grid.Items values={[
                [Title.Name, width.name],
                [Title.Comment, width.comment], 
              ]} last={1} upper={true} />
            </Control.List.Title>
            {!loading && !error && Array.isArray(examtypeData) && (
              <Control.Grid.Row>
                {examtypeData.map((examtypeData) => { return (
                <Control.Grid.Data<ExamType> key={examtypeData.examtype_id} itemKey={examtypeData.examtype_key} data={examtypeData} setMenuPosition={setMenuPosition} setSelectedData={setselectedExamType} setShowMenu={setShowMenu} >
                  <Control.Grid.Check keyId={examtypeData.examtype_key} selectedItems={selectedItems} toggleSelection={Form.Select.Toggle} setSelectedItems={setSelectedItems} />
                  <Control.Grid.Modify path={Utility.Join.Edit(Privilege, formName, examtypeData.examtype_key)} iframeRef={iframeRef} Privilege={Privilege} />
                  <Control.Grid.Items values={[
                    [examtypeData.examtype_name, width.name],
                    [examtypeData.examtype_comment, width.comment],
                  ]} />
                  <Control.Grid.Actions>
                    <Control.Action.All formName={formName} activeId={activeId} keyId={examtypeData.examtype_key} iframeRef={iframeRef} setSelectedItems={setSelectedItems} setConfirm={setConfirm} Privilege={Privilege}><></></Control.Action.All>
                  </Control.Grid.Actions>
                </Control.Grid.Data>)})}
            </Control.Grid.Row>)}
          </Control.List.Box>
        </Control.List.Data>
        <Control.List.Info>
          <Control.RecordInfo pageNo={pno} pageRows={rows} loading={loading} error={error} dataLength={examtypeData.length} />
          <Control.Pagination pageNo={pno} onChange={(page) => setPno(page)} />
        </Control.List.Info>
      </Control.List.Panel>
      {showMenu && (<div ref={contextMenuRef}><Control.ListContextMenu showMenu={showMenu} formName={formName} onCreate={() => Form.Show.Popup(iframeRef, formName)} onModify={()=>Form.Show.Popup(iframeRef, Utility.Join.Edit(Privilege, formName,selectedExamType?.examtype_key))} onDelete={() => Toast.Delete.SingleRecord(activeId, selectedExamType?.examtype_key, setSelectedItems, setConfirm)} onClose={() => Form.Parent.TabClose()} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Control.FormPopup iframeRef={iframeRef} onRefresh={callListData} />
      <Actions.List />
    </Control.List.Frame>
  );
};

export default ExamTypeList;